/*@flow*/
import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import FreeModal from 'comps/FreeModal';
import { css } from '@emotion/core';
import { type HOC, lifecycle } from 'recompose';
import type { StatusT, ProgressResponse } from '../';

type InputPropsT = {|
  onProgress: string => Promise<ProgressResponse>,
  onClose: Function,
  isOpen: boolean,
|};
type EnhancedPropsT = {
  ...InputPropsT,
  status: StatusT,
  percent: number,
  errors: string[],
};

const Enhancer: HOC<EnhancedPropsT, InputPropsT> = lifecycle({
  percent: 10,
  trackProgress(payload: ProgressResponse) {
    // When the tracker hits 'Success', reload the page
    if (payload.status === 'Success') {
      this.stoptracker();
      this.setState({ percent: 100 });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      // Update the interFface.
      if (payload.percent > 0 && this.percent < 100) {
        this.percent = payload.percent + 1;
      }
      this.setState({ ...payload, percent: this.percent });
    }
  },
  startTracker() {
    // Periodically call the backend with onProgress
    this.interval = setInterval(() => {
      this.props.onProgress().then(res => this.trackProgress(res));
    }, 2000);
  },
  stoptracker() {
    clearInterval(this.interval);
  },
  componentDidUpdate(prevProps: EnhancedPropsT) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.startTracker();
    } else if (!this.props.isOpen && prevProps.isOpen) {
      this.stoptracker();
    }
  },
  componentDidMount() {
    this.setState({ percent: 10 });
  },
  componentWillUnmount() {
    this.stoptracker();
  },
});

const Component = (props: EnhancedPropsT) => (
    <FreeModal
      id="assetDestroyProgress"
      isOpen={props.isOpen}
      height="70vh"
      requestClosePortal={props.onClose}
      naked
    >
      <div
        css={css(`
        display: grid;
        grid-template-rows: 50px 1fr 40px;
        height: 100%;
      `)}
      >
        <h2>Deleting records...</h2>
        <div
          css={css(`
            display: grid;
            align-items: center;
            justify-items: center;

            .progress {
              width: 80%;
              height: 38px;
              & > div {
                display: grid;
                align-items: center;
              }
            }
          `)}
        >
          <ProgressBar now={props.percent} label={`${props.percent}%`} />
        </div>
        <p>
          This page will automatically refresh when the action is completed.
        </p>
      </div>
    </FreeModal>
  );
export default Enhancer(Component);
